/**
 * Returns true if the hex color has a perceived luminance above the given
 * threshold (default 0.75), i.e. it is "very light" and would be hard to
 * see on a white background.
 */
export function isLightColor(hex: string, threshold = 0.75): boolean {
  const h = hex.replace('#', '')
  if (h.length !== 6) return false
  const r = parseInt(h.slice(0, 2), 16)
  const g = parseInt(h.slice(2, 4), 16)
  const b = parseInt(h.slice(4, 6), 16)
  // Perceived luminance (ITU-R BT.601 coefficients)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > threshold
}

/**
 * CSS filter that draws a thin dark contour around an SVG icon.
 * Use this when the icon fill color is too light to see on a white background.
 */
export const LIGHT_COLOR_CONTOUR_FILTER =
  'drop-shadow(0 0 0.5px rgba(0,0,0,0.5)) drop-shadow(0 0 1px rgba(0,0,0,0.25))'
